var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30435 21C4.95652 21 4.65217 20.8697 4.3913 20.6092C4.13043 20.3486 4 20.0446 4 19.6972V6.66948C4 6.32207 4.13043 6.01809 4.3913 5.75754C4.65217 5.49698 4.95652 5.36671 5.30435 5.36671H14.1087L7.91304 11.5766V17.0917H13.4348L19.6522 10.8384V19.6972C19.6522 20.0446 19.5217 20.3486 19.2609 20.6092C19 20.8697 18.6957 21 18.3478 21H5.30435ZM9.21739 15.7889V12.0977L15.7826 5.54041L19.5 9.18818L12.913 15.7889H9.21739ZM20.4348 8.25452L16.7174 4.60676L17.9565 3.36912C18.2029 3.12304 18.5109 3 18.8804 3C19.25 3 19.558 3.13028 19.8043 3.39083L21.6304 5.23643C21.8768 5.49698 22 5.80458 22 6.15923C22 6.51387 21.8696 6.81423 21.6087 7.06031L20.4348 8.25452Z",
    fill: "#0B319D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.018e3ef61be7a9be6b23b2d3047dbd74.svg";
export { ForwardRef as ReactComponent };